import authReducer, * as auth from './auth'
import articlesReducer, * as articles from './articles'

// @dependencycycle This injection creates a dependency cycle between redux store and local storage
import clubsReducer, * as clubs from './clubs'

import teamsReducer, * as teams from './teams'
import teamReducer, * as team from './team'
import playersReducer, * as players from './players'
import seasonsReducer, * as seasons from './seasons'
import matchesReducer, * as matches from './matches'
import trainingsReducer, * as trainings from './trainings'
import drillsReducer, * as drills from './drills'
import trainingPackagesReducer, * as trainingPackages from './trainingPackages'
import lineupsReducer, * as lineups from './lineups'
import videosReducer, * as videos from './videos'
import sequencesReducer, * as sequences from './sequences'
import favoritesReducer, * as favorites from './favorites'
import usersReducer, * as users from './users'
import eventsReducer, * as events from './events'
import themesReducer, * as themes from './themes'
import generalEventsReducer, * as generalEvents from './general_events'

export {
  auth,
  articles,
  clubs,
  teams,
  team,
  players,
  seasons,
  matches,
  trainings,
  drills,
  trainingPackages,
  lineups,
  videos,
  sequences,
  favorites,
  users,
  events,
  themes,
  generalEvents,
}

export default {
  auth: authReducer,
  articles: articlesReducer,
  clubs: clubsReducer,
  teams: teamsReducer,
  team: teamReducer,
  players: playersReducer,
  seasons: seasonsReducer,
  matches: matchesReducer,
  trainings: trainingsReducer,
  drills: drillsReducer,
  trainingPackages: trainingPackagesReducer,
  lineups: lineupsReducer,
  videos: videosReducer,
  sequences: sequencesReducer,
  favorites: favoritesReducer,
  users: usersReducer,
  themes: themesReducer,
  events: eventsReducer,
  generalEvents: generalEventsReducer,
}
